import { render, staticRenderFns } from "./RowSectionInternational.vue?vue&type=template&id=03948d56&scoped=true&"
import script from "./RowSectionInternational.vue?vue&type=script&lang=js&"
export * from "./RowSectionInternational.vue?vue&type=script&lang=js&"
import style0 from "./RowSectionInternational.vue?vue&type=style&index=0&id=03948d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03948d56",
  null
  
)

export default component.exports